import React, { useState } from 'react'
import './about.css'
import aboutImg from '../assest/Rectangle 529.png'
import {Service,schedule} from '../assest/index'
import { Link } from 'react-router-dom'


const About = () => {
    const [aboutLink, setAboutLink] = useState(true)
  return (
    <>
    <div className="container-fluid">
    <div className="container">
        <div className="row py-4">
               <div className=" d-none d-lg-block col-lg-6 pt-4 pe-5">
                   <img src={aboutImg} alt="about img" className='img-fluid' style={{height:'426px'}} />
               </div>
               <div className="col-sm-12 col-lg-6 py-4">
                    <div className="row">
                        <div className="col-12">
                        <p className="section-subheading text-center text-lg-start">ABOUT</p>
                        <h2 className="section-heading text-center text-lg-start">
                            Primepath International Movers Pvt Ltd is a professional packers & movers in India.
                        </h2>
                        </div>
                        <div className="col-12">
                        <p align="justify" className="about-text text-center text-lg-start py-2">Primepath International Movers Pvt Ltd is a professional and reputed relocation service provider based in Bangalore. Our main objective is to make the process of goods shifting relatively easy for you. We make sure that you have an unforgettable experience by minimizing all the worries related to goods shifting.</p>
                        </div>
                        <div className="col-12">
                              <div className="row">

                            <div className="col-12 d-lg-block d-flex align-items-center justify-content-center col-lg-4">
                                 {aboutLink? <>
                                    <a href="https://wa.me/7992921414" target='_blank' className={`logo-width about-logo-container1 mb-3 mb-lg-0  p-3 my-2  border  ${aboutLink}`} >
                                    <div className="about-log">
                                    <i class="bi bi-clock-fill"  style={{fontSize:'2rem'}}></i>
                                    </div>
                                    <p style={{textAlign:'center'}} className='logo-text'>Schedule<br/> Physical Survey</p>
                                   </a>
                                 </>:<>
                                 <a  href="https://wa.me/7992921414" target='_blank' className={`logo-width about-logo-container mb-3 mb-lg-0  p-3 my-2  border  ${aboutLink}`} >
                                    <div className="about-log">
                                    <i class="bi bi-clock-fill"  style={{fontSize:'2rem'}}></i>
                                    </div>
                                    <p style={{textAlign:'center'}} className='logo-text'>Schedule<br/> Physical Survey</p>
                                   </a>
                                 </>}
                                                                                                                                                             
                        
                                </div>
                             
                                <div className=" col-6 col-lg-4 d-lg-block d-flex align-items-center justify-content-center">
                                <a href="https://wa.me/7992921414" target='_blank' onMouseOver={()=>setAboutLink(false)} onMouseOut={()=>setAboutLink(true)}  className='about-logo-container p-3 my-2   border' >
                                    <div className="about-logo">
                                    <i class="bi bi-whatsapp" style={{fontSize:'2rem'}}></i>
                                    </div>
                                    <p style={{textAlign:'center'}}>Schedule<br/> WhatsApp Survey</p>
                                   </a>
                               
                                </div>

                                <div className="col-6 col-lg-4 d-lg-block d-flex align-items-center justify-content-center">
                                <a href="https://wa.me/7992921414" target='_blank' onMouseOver={()=>setAboutLink(false)} onMouseOut={()=>setAboutLink(true)}  className='about-logo-container p-3 my-2  border' >
                                    <div className="about-logo">
                                    <i class="bi bi-box-seam-fill" style={{fontSize:'2rem'}}></i>
                                    </div>
                                    <p style={{textAlign:'center'}}>Damage<br/>  Recover</p>
                                   </a>
                               
                               
                    
                                </div>
                              </div>
                        </div>
                    </div>
               </div>
               </div>
        </div>
    </div>
        {/* <div className="about-section mt-5 section section-margin " style={{padding:'1rem'}}>
    <div className="container">
        <div className="row about">
            
            <div className="col-sm-12 col-lg-6 about-left">
                <p className="section-subheading">ABOUT</p>
                <h2 className="section-heading">
                 Primepath International Movers Pvt Ltd is a professional packers & movers in India.
                 </h2>

                  <p align="justify" className="about-text py-3">Primepath International Movers Pvt Ltd is a professional and reputed relocation service provider based in Bangalore. Our main objective is to make the process of goods shifting relatively easy for you. We make sure that you have an unforgettable experience by minimizing all the worries related to goods shifting.</p>
            </div>
            <div className="col-sm-12 col-lg-6 about-right">
                 <div className="row ">
                    <div className="col-12 d-flex justify-content-center align-items-center ">
                        <a className="link-a about-tile my-3" >
                            <div className='d-flex justify-content-center align-items-center flex-column about-img'>
                            <i class="bi bi-clock-fill" style={{fontSize:'2rem'}}></i>
                                <p style={{textAlign:'center'}}>Schedule<br/> Physical Survey</p>
                            </div>
                            
                        </a>
                    </div>
                    <div className="col-6 d-flex justify-content-center align-items-center">
                        <Link to='/help' className="link-a about-tile my-3">
                            <div className='d-flex justify-content-center align-items-center flex-column about-img'>
                            <i class="bi bi-whatsapp" style={{fontSize:'2rem'}}></i>
                            <p style={{textAlign:'center'}}>Schedule<br/> WhatsApp Survey</p>
                            </div>
                           
                        </Link>
                    </div>
                    <div className="col-6 d-flex justify-content-center align-items-center">
                        <Link to='/' className="link-a about-tile my-3" >
                            <div className='d-flex justify-content-center align-items-center flex-column about-img'>
                            <i class="bi bi-box-seam-fill" style={{fontSize:'2rem'}}></i>
                            <p style={{textAlign:'center'}}>Damage<br/>  Recover</p>
                            </div>
                        </Link>
                    </div>
                 </div>
            </div>
        </div>
    </div>
</div> */}
    </>
  )
}

export default About